<!-- <trv-global-messages></trv-global-messages> -->
<!-- <trv-fullscreen-loader></trv-fullscreen-loader>-->
<trv-dashboard>
   <trv-dashboard-top-nav menuLabel="Tjäldjup">
   </trv-dashboard-top-nav >
  <trv-dashboard-page-header customTitle="TRV Tjäldjup">TRV Tjäldjup</trv-dashboard-page-header> 
  <trv-dashboard-content >
    <trvapp-home></trvapp-home>
</trv-dashboard-content>
  <trv-dashboard-footer>
    <ul class="list-unstyled list-inline mb-0 footer-list">
      <li><strong>Trafikverket</strong></li>
      <li>Användarstöd</li>
      <li>Telefon: 010-125 10 10</li>
      <li>
        <a href="https://trafikverket.se" target="_blank">
          Till Trafikverket.se
        </a>
      </li>
    </ul>

   
  </trv-dashboard-footer>
</trv-dashboard> 
